<template>
  <div>
    <div
        class="images"
        @dragover="dragover($event)"
        @dragleave="dragleave"
        @drop="drop"
    >
      <div
          v-for="(image, index) in previewImage"
          :key="index"
          class="imagePreviewWrapper"
          :class="{ 'selected': selectedImageIndex == index, 'is-title-image': image == titleImage  }"
          :style="{ 'background-image': `url(${image})` }"
          @click="showMenu(index, image, $event)"
      >
      </div>
      <label
          data-class="custom-file-upload"
          :class="['custom-file-upload', {disableInput}]"
      >
        <input
            id="assetsFieldHandle"
            ref="file"
            type="file"
            name="fields[assetsFieldHandle][]"
            accept=".jpg,.jpeg,.png"
            :disabled="disableInput"
            @change="onChange"
        >
        <md-icon class="add_photo_alternate">add_photo_alternate</md-icon>
        <span>Fotos ziehen und ablegen</span>
      </label>

      <label
          data-class="custom-file-upload"
          :class="['custom-file-upload by-url', {disableInput}]"
      >
        <input
            type="file"
            :disabled="disableInput"
            @click="showMenu(null, '', $event)"
        >
        <md-icon class="add_photo_alternate">add_photo_alternate</md-icon>
        <span>Add photo by url</span>
      </label>
    </div>

    <md-field v-if="selectedImage">
      <label>Add Image by url</label>
      <md-input v-model="selectedImage"></md-input>
      <div class="buttons-container">
        <md-button class="md-just-icon md-round button-with-icon add" @click="addNewLink">
          <md-icon class="md-layout-item">add</md-icon>
        </md-button>

        <md-button class="md-just-icon md-round button-with-icon trash" @click="removePhoto">
          <md-icon class="md-layout-item">delete</md-icon>
        </md-button>

        <md-button class="md-just-icon md-round button-with-icon set-main" v-if="canSetTitleImage" @click="setAsMainPhoto">
          <md-icon class="md-layout-item">grade</md-icon>
        </md-button>
      </div>
    </md-field>
  </div>
</template>

<script>
export default {
  name: 'DragAndDropComponent',
  delimiters: ['${', '}'],
  props: {
    currentImages: {},
    titleImage: String,
    allowMultiple: Boolean,
    canSetTitleImage: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      previewImage: [],
      selectedImageIndex: null,
      filesInInputFiled: false,
      disableInput: false,
      selectedImage: undefined,
    }
  },
  watch: {
    currentImages(data) {
      this.previewImage = data;
      this.disableInput = !this.allowMultiple && data.length == 1;
    },
  },
  mounted() {
    if (this.currentImages && this.currentImages.length) {
      this.previewImage = this.currentImages
    }
    if (this.allowMultiple) {
      let htmlEl = document.getElementById('assetsFieldHandle');
      htmlEl.setAttribute('multiple', 'true');
    }
    if (this.currentImages && this.currentImages.length && !this.allowMultiple) {
      this.disableInput = !this.allowMultiple && this.currentImages.length == 1;

    }
  },
  methods: {
    onChange() {
      let input = this.$refs.file
      let files = input.files;
      if (files) {
        for (let i = 0; i < files.length; i++ ) {
          const formData = new FormData();
          formData.append("challenge", files[i]);

          let data = {
            formData: formData,
            url: "/rest/image/challenge"
          }

          this.$store
              .dispatch("uploadImage", data)
              .then(res => {
                if (res.url) {
                  this.previewImage.push(res.url);
                  if (!this.allowMultiple) {
                    this.disableInput = true;
                    this.filesInInputFiled = true;
                  }
                  this.$emit('photoSet', res.url)
                  this.$emit('uploadedImages', this.previewImage)
                }
              })
              .catch(err => {
                this.$notify({
                  timeout: 5000,
                  message: err.message,
                  icon: "add_alert",
                  horizontalAlign: "right",
                  verticalAlign: "top",
                  type: "error"
                });
              });
        }
      }
    },

    showMenu(i , image, event) {
      event.preventDefault();
      event.stopPropagation();
      if (i != null) {
        this.selectedImage = this.selectedImage === image ? undefined : image;
      } else {
        this.selectedImage = ' ';
      }
      this.selectedImageIndex = this.selectedImageIndex === i ? null : i;
    },

    dragover(event) {
      event.preventDefault();
      if (!event.currentTarget.classList.contains('drop-are-active')) {
        event.currentTarget.classList.add('drop-are-active');
      }
      if (!event.currentTarget.classList.contains('drop-is-inactive') && (this.disableInput || this.filesInInputFiled)) {
        event.currentTarget.classList.add('drop-is-inactive');
      }
    },
    dragleave(event) {
      event.currentTarget.classList.remove('drop-are-active');
      event.currentTarget.classList.remove('drop-is-inactive');
    },
    drop(event) {
      event.preventDefault();
      event.currentTarget.classList.remove('drop-are-active');
      event.currentTarget.classList.remove('drop-is-inactive');

      if (this.allowMultiple) {
        this.$refs.file.files = event.dataTransfer.files;
        this.onChange();
      } else {
        if (event.dataTransfer.files.length > 1 || this.filesInInputFiled) {
          this.$notify({
            timeout: 5000,
            message: 'Sie können nur ein Bild hochladen',
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "error"
          });
          return;
        } else {
          this.$refs.file.files = event.dataTransfer.files;
          this.filesInInputFiled = event.dataTransfer.files.length;
          this.disableInput = true;

          this.onChange()
        }
      }
    },
    onInputClick(event) {
      event.preventDefault()
      event.stopPropagation()
    },
    onInputChange(event, index) {
      this.$emit('uploadedImages', event, index)
    },
    addNewLink() {
      if (this.selectedImageIndex != undefined) {
        this.previewImage[this.selectedImageIndex] = this.selectedImage;
      } else {
        this.previewImage.push(this.selectedImage);
      }
      this.$emit('uploadedImages', this.previewImage);
      this.selectedImage = undefined;
      this.selectedImageIndex = undefined;
    },
    removePhoto() {
      this.previewImage.splice(this.selectedImageIndex, 1);
      if (this.titleImage == this.selectedImage) {
        this.$emit('updateTitleImage', '');
      }
      if (!this.allowMultiple) {
        this.disableInput = false;
        this.filesInInputFiled = false;
      }
      this.selectedImage = undefined;
    },
    setAsMainPhoto() {
      this.$emit('updateTitleImage', this.selectedImage);
    }
  }
}
</script>

<style lang="scss">
.images {
  display: flex;
  border: 2px dashed #005FB6;
  padding: 16px;
  width: 100%;
  flex-wrap: wrap;
  .imagePreviewWrapper {
    width: 72px;
    height: 72px;
    display: block;
    cursor: pointer;
    margin: 0 4px 6px 0;
    background-size: cover;
    background-position: center center;
    &.is-title-image, &.selected {
      border: 1px solid red;
    }
  }
  input[type="file"] {
    display: none;
  }
  .custom-file-upload {
    border: 1px dashed #e2c6c6;
    cursor: pointer;
    width: 72px;
    height: 72px;
    font-size: 10px;
    line-height: 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    text-align: center;
    &.by-url {
      margin-left: 10px;
    }
    &.disableInput {
      cursor: unset;
      opacity: 0.5;
    }
  }
}

.drop-are-active {
  border: 2px dashed #0ddB08;
}
.drop-is-inactive {
  border: 2px dashed red;
}
.buttons-container {
  display: flex;
  justify-content: space-between;
  width: 100px;
  .button-with-icon {
    min-width: 30px;
    height: 30px;
    width: 30px;
    display: flex;
    i {
      font-size: 16px !important;
      justify-content: center;
    }
  }
}
</style>
